var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.screenwidth>1500?"dw2":"dw1"},[_c('div',{staticClass:"dwstr"},[_vm._v(" 客服微信 ")]),_vm._v(" "),_c('img',{class:_vm.screenwidth>1500? 'dwimg2':'dwimg',attrs:{"src":_vm.img1}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d34e1cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/new/lxkf.vue
// module id = null
// module chunks = 